// frontend/src/errors/ErrorContext.tsx
// Global error state management context

import React, { createContext, useContext, useState, useCallback } from 'react';
import { AppError } from './errorTypes';

interface ErrorContextValue {
  currentError: AppError | null;
  setError: (error: AppError | null) => void;
  clearError: () => void;
}

const ErrorContext = createContext<ErrorContextValue | undefined>(undefined);

export const ErrorProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [currentError, setCurrentError] = useState<AppError | null>(null);

  const clearError = useCallback(() => {
    setCurrentError(null);
  }, []);

  return (
    <ErrorContext.Provider
      value={{ currentError, setError: setCurrentError, clearError }}
    >
      {children}
    </ErrorContext.Provider>
  );
};

export const useErrorContext = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useErrorContext must be used within ErrorProvider');
  }
  return context;
};
